document.addEventListener('DOMContentLoaded', () => {
    initAWFilters();
});

function initAWFilters() {
    const sectionId = 'main-collection-aw'; 

    // 1. Capture changes to filters
    document.addEventListener('change', (e) => {
        if (e.target.closest('#CollectionFiltersForm')) {
            if (e.target.classList.contains('price-slider')) {
                syncPriceSliders(e.target);
            }
            fetchFilteredProducts();
        }
    });

    document.addEventListener('input', (e) => {
        if (e.target.classList.contains('price-slider')) {
            syncPriceSliders(e.target);
        }
    });

    // 2. Handle Sort By Clicks & "Clear All" Tags
    document.addEventListener('click', (e) => {
        // Handle sorting selection
        const sortTrigger = e.target.closest('.sort-trigger');
        if (sortTrigger) {
            e.preventDefault();
            const sortValue = sortTrigger.getAttribute('data-value');
            const form = document.querySelector('#CollectionFiltersForm');
            
            if(form) {
                // Update hidden input and visually set Active class
                form.querySelector('input[name="sort_by"]').value = sortValue;
                document.querySelectorAll('.sort-trigger').forEach(el => el.classList.remove('active'));
                sortTrigger.classList.add('active');

                fetchFilteredProducts();
            }
        }

        // Handle Clear all & Clear active tags
        const clearTrigger = e.target.closest('.filter-clear-trigger');
        if (clearTrigger) {
            e.preventDefault();
            const url = clearTrigger.getAttribute('href');
            fetchFilteredProducts(url);
        }
    });

    // 3. Price Slider Synchronization
    function syncPriceSliders(slider) {
        const form = slider.closest('#CollectionFiltersForm');
        const isMin = slider.getAttribute('data-target') === 'min';
        
        if (isMin) {
            const minInput = form.querySelector('.price-input-min');
            if (minInput) minInput.value = slider.value;
        } else {
            const maxInput = form.querySelector('.price-input-max');
            if (maxInput) maxInput.value = slider.value;
        }
    }

    // 4. AJAX Fetch Function
    function fetchFilteredProducts(fetchUrl = null) {
        const form = document.querySelector('#CollectionFiltersForm');
        let url = fetchUrl;

        document.querySelector('#ProductGridContainer').style.opacity = '0.5';

        // Build the URL purely from active fields, excluding anything blank
        if (!url && form) {
            const formData = new FormData(form);
            const searchParams = new URLSearchParams();

            for (const [key, value] of formData.entries()) {
                // THIS FIXES THE $0-$0 BUG: Ignores inputs that are completely empty
                if (value.trim() !== '') {
                    searchParams.append(key, value);
                }
            }
            url = `${window.location.pathname}?${searchParams.toString()}`;
        }

        // Update URL history so the user can copy/paste it
        window.history.pushState({ path: url }, '', url);

        // Fetch new section HTML
        fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`)
            .then(response => response.text())
            .then(html => {
                const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

                const newProductGrid = parsedHTML.querySelector('#ProductGridContainer');
                const newFiltersForm = parsedHTML.querySelector('#CollectionFiltersForm');
                const newCount = parsedHTML.querySelector('#ProductCountContainer');

                // Swap out Product Grid
                if (newProductGrid) {
                    document.querySelector('#ProductGridContainer').innerHTML = newProductGrid.innerHTML;
                    document.querySelector('#ProductGridContainer').style.opacity = '1';
                }
                
                // Swap out only the innerHTML of the FORM so the dropdown stays open
                if (newFiltersForm) {
                    document.querySelector('#CollectionFiltersForm').innerHTML = newFiltersForm.innerHTML;
                }

                // Swap out product count at the top
                if (newCount) {
                    document.querySelector('#ProductCountContainer').innerHTML = newCount.innerHTML;
                }
            })
            .catch(error => {
                console.error('Error fetching products:', error);
                document.querySelector('#ProductGridContainer').style.opacity = '1';
            });
    }
}